<template>
    <div class="fill-height">
        <TabBasic :key="refreshCount+'zoneTab'" ref="tabBasic" :items="items" :zone-ids="selectedZoneIDs" :filter-open="filterOpen"
                  show-breadcrumbs
                  @refreshPage="refreshPage">
            <template v-slot:header>
                <v-spacer/>
                <slot name="header"/>
                <v-col v-show="$route.name === 'zoneMap'" cols="5" lg="3">
                    <div v-if="isAdmin" class="zone-add">
                      <router-link :to="{name: 'addZone'}">
                        <v-btn class="accent" icon small rounded @click="openAddEditDialog = true">
                            <v-icon color="accentText">mdi-plus</v-icon>
                        </v-btn>
                     </router-link>
                    </div>
                    <SelectFilter v-model="selectedZoneIDs" :items="filterItems" :show-all="$t('zones.showAllZones')"
                                  color="accentText" @openMenu="openMenu"/>
                </v-col>
            </template>
        </TabBasic>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";
import SelectFilter from "@/components/reusable/SelectFilter/SelectFilter";

export default {
  name: "ZonesBasic",
  components: {SelectFilter, TabBasic},
  mounted() {
    if (this.organizationId) {
      this.initZones();
    }
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    filterItems() {
      return this.zones.map((zone) => ({value: zone.ZoneID, text: zone.Name}));
    },
    routeName() {
      return this.$route.name;
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    }
  },
  watch: {
    routeName() {
      this.changeRoute = true;
      setTimeout(() => {
        this.changeRoute = false;
      }, 500);
    },
    organizationId() {
      // this.initCircles();
    }
  },
  data() {
    return {
      tab: null,
      refreshCount: 0,
      changeRoute: false,
      items: [
        {
          title: this.$t('circles.map'),
          to: {
            name: 'zoneMap'
          }
        },
        {
          title: this.$t('zones.myZones'),
          to: {
            name: 'myZones'
          }
        }
      ],
      zones: [],
      selectedZoneIDs: [],
      openAddEditDialog: false,
      filterOpen: false,
    };
  },
  methods: {
    initZones() {
      const url = this.$store.getters.zones;
      this.axios.get(url).then(({data}) => {
        this.zones = data.Result;
      });
    },
    refreshPage() {
      this.selectedZoneIDs = this.filterItems.map(item => item.value);
      if (this.changeRoute) {
        this.refreshCount++;
      }
    },
    openMenu(val) {
      this.filterOpen = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "zones-basic";
</style>